/**
 * Clickable header row of the Errors bucket card: error icon, label, total count (open RMAs with
 * unresolved errors) and a chevron that reflects the popup's open state. It is the floating-ui
 * reference element, so open/close (click + keyboard) is driven by the trigger props passed in.
 */
import { observer } from "mobx-react";
import { Ref } from "react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import IconChevronDown from "../../../../../../components/icons/icon-chevron-down/icon-chevron-down";
import IconError from "../../../../../../components/icons/icon-error/icon-error";

interface IProps {
    label: string;
    total: number;
    open: boolean;
    disabled: boolean;
    triggerRef: Ref<HTMLDivElement>;
    triggerProps: Record<string, unknown>;
}

const RmaListErrorsBucketCardRow: React.FC<IProps> = observer(({ label, total, open, disabled, triggerRef, triggerProps }) => (
    <div
        ref={triggerRef}
        role="button"
        tabIndex={disabled ? -1 : 0}
        className="rma-list-errors-bucket__row"
        {...triggerProps}
    >
        <span className="rma-list-errors-bucket__icon">
            <IconError color="var(--color-semantic-danger)" />
        </span>
        <FontBody2>{label}</FontBody2>
        <span className="rma-list-errors-bucket__count">{total}</span>
        <span className={`rma-list-errors-bucket__chevron${open ? " open" : ""}`}>
            <IconChevronDown color="var(--color-primary-2-50)" />
        </span>
    </div>
));

export default RmaListErrorsBucketCardRow;
